import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const config: LayoutConfigTypes = {
  themeName: process.env.VUE_APP_NAME,
  themeVersion: process.env.VUE_APP_VERSION,
  demo: process.env.VUE_APP_NAME,
  brand: {
    name: process.env.VUE_APP_NAME,
    logo: {
      dark: "/media/logos/sisdeu3.png",
      light: "/media/logos/sisdeu3.png"
    }
  },
  main: {
    type: "default",
    primaryColor: "#009EF7",
    logo: {
      dark: "/media/logos/fedup_brand.png",
      light: "/media/logos/fedup_brand.png",
    },
  },
  illustrations: {
    set: "sketchy-1",
  },
  loader: {
    logo: "media/logos/isologo.png",
    display: true,
    type: "spinner-logo",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "font",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: false,
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: false,
    },
  },
  pageTitle: {
    display: false,
    breadcrumb: true,
    direction: "column",
  },
  aside: {
    display: true,
    theme: "light",
    fixed: true,
    menuIcon: "svg",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: "fluid",
  },
  footer: {
    width: "fluid",
  },
};

export default config;
